import React from "react";
import { useTranslation } from "react-i18next";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function NewsTags({ tags = [], selectedTags = [], toggleTag }) {
  const { i18n } = useTranslation();
  const lang = i18n.language === "fr" ? "Fr" : "En";

  return (
    <div className="flex flex-wrap gap-3 mt-6">
      {tags.map((tag) => {
        const active = selectedTags.includes(tag.id);
        const label = tag[`name${lang}`]; // nameFr ou nameEn automatiquement

        return (
          <button
            key={tag.id}
            onClick={() => toggleTag(tag.id)}
            className={`
              flex items-center gap-2
              px-4 py-2 rounded-full text-sm font-medium transition-all
              border border-[#FFD76A]
              ${
                active
                  ? "bg-[#FFD76A] text-[#3a3a3a] shadow-md hover:bg-[#FFE28F]"
                  : "bg-white text-[#3a3a3a] hover:bg-[#FFF3AF]"
              }
            `}
          >
            <span>{label}</span>

            {active && <XMarkIcon className="h-4 w-4 text-[#3a3a3a]" />}
          </button>
        );
      })}
    </div>
  );
}
